/** Access rules API endpoints, merged into the platform API client. */
export const accessApiEndpoints: Record<string, string> = {
  accessMe: "/ext/access/me/",
  accessCodeSetup: "POST:/ext/access/code/setup/",
  accessCodeConfirm: "POST:/ext/access/code/confirm/",
  accessCodeVerify: "POST:/ext/access/code/verify/",
  accessCodeRemove: "POST:/ext/access/code/remove/",
  accessCodeRecovery: "POST:/ext/access/code/recovery/",
  accessPeople: "/ext/access/people/",
  accessPerson: "/ext/access/people/:pk/",
  accessSignOff: "POST:/ext/access/people/review/",
  accessRemove: "POST:/ext/access/people/:pk/remove/",
  accessSignOut: "POST:/ext/access/people/:pk/sign-out/",
  accessUnlock: "POST:/ext/access/people/:pk/unlock/",
};
